import React from 'react';
import Contact from '../components/Contact';
import './ContactUs.css';

const ContactUs = () => {
  return (
    <div className="contact-us-page">
      <Contact />
    </div>
  );
};

export default ContactUs;
